import { render, staticRenderFns } from "./VisionboardPage.vue?vue&type=template&id=c31bfa18&"
import script from "./VisionboardPage.vue?vue&type=script&lang=js&"
export * from "./VisionboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports